
// React
import React, { useEffect, useState, useRef } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

// Components
import Modal2Component from 'shared/components/modal2/Modal2Component';
import InputFieldComponent from 'shared/components/input-field/InputFieldComponent';
import FormComponent from 'shared/components/form/FormComponent';
import PrimaryButtonComponent from 'shared/components/primary-button/PrimaryButtonComponent';
import LeagueCountrySearchIconComponent from 'app/leagues/components/league-member-search-icon/LeagueCountrySearchIconComponent';
import TextButtonComponent from 'shared/components/text-button/TextButtonComponent';

// Styles
import './EditEmailPhoneModalComponent.styles.css';

// i18n
import { withTranslation } from 'react-i18next';

// Validators
import { OtpValidator2 } from 'shared/validators/SignUpValidator';
import { EmailRequiredValidator, RequiredValidator, PhoneNumberRequiredValidator } from 'shared/validators/RequiredValidator';

// Constants
import {recaptcha_public_key} from "config/GlobalData";

//Functions
import { generateBaloaToken } from 'shared/functions/GenerateBaloaToken';

// React device detect
import { isMobile } from 'react-device-detect';

function EditEmailPhoneModalComponent( props ) {

    const formRef = React.useRef();
    const recaptchaRef = React.useRef();
    const [recapcha, setRecapcha] = useState(undefined);

    const initialSeconds = 120;
    const [totalSeconds, setTotalSeconds] = useState(initialSeconds);
    const timerRef = useRef(null);

    const [isFormValid, setIsFormValid] = useState(false);

    const formInitialValues = {
        email:  '',
        phone:  '',
        code: '',
        email_code: '',
    }

    async function info (values){
        
        if(values.email !== "" && !props.send_email_otp){
            let new_data = { 
                "email": values.email,
                "user_id": props.user_id,
            }
            props.onEditEmailPhone( props.field ,new_data );
        }else if(values.phone !== "" && values.country_code !== "" && !props.send_phone_otp){
            let token = await generateBaloaToken(values.phone);
            let new_data = { 
                "phone": values.phone,
                "country_code": values.country_code.value,
                "user_id": props.user_id,
                "recapcha" : recapcha,
                "baloa_token": token,
            }
            if(recapcha){
                props.onEditEmailPhone( props.field ,new_data );
            }            
        }else if(props.send_phone_otp && values.code !== ""){
            //console.log('valida otp phone');
            let new_data = { 
                "phone": values.phone,
                "country_code": values.country_code.value,
                "code": values.code
            }
            props.onEditEmailPhone( 'code' ,new_data );
        }else if(props.send_email_otp && values.email_code !== ""){
            //console.log('valida otp email');
            let new_data = { 
                "email": values.email,
                "code": values.email_code,
                "user_id": props.user_id,
            }
            props.onEditEmailPhone( 'email_code' ,new_data );
        }
    }

    const getValidator=(field)=>{
        switch (field){
            case 'email':
                return EmailRequiredValidator;

            case 'phone':
                return PhoneNumberRequiredValidator;
            
            case 'code':
                return OtpValidator2;

            // no default
        }
    }

    const onChangeCaptcha = (token) => {
        if(token){
            setRecapcha(token)
        }        
    }

    const startTimer = () => {
        clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setTotalSeconds((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const resetTimer = () => {
        clearInterval(timerRef.current);
        setTotalSeconds(initialSeconds);
        startTimer();
    };

    useEffect(() => {
        startTimer();
        return () => clearInterval(timerRef.current);
    }, []);
    
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    useEffect(() => {
        const interval = setInterval(async () => {
            if (formRef.current) {
                const errors = await formRef.current.validateForm();
                setIsFormValid(Object.keys(errors).length === 0);
            }
        }, 300); // cada 300ms

        return () => clearInterval(interval);
    }, []);

    return (

        <Modal2Component 
            isOpen={props.isOpen} 
            onClose={props.onClose}
            title={props.t(`settings.editInfoModal.${props.field}`)}
            className={'edit-email-phone-modal'}
        >
            <FormComponent 
                    formInitialValues={formInitialValues} 
                    onSubmit={( values, actions ) => { 
                        //console.log('values',values);
                        info(values);
                    }}
                    className="edit-email-phone-modal__form"
                    functionDisabled={ ()=>{} }
                    innerRef={formRef}
                >
                    
                    {props.field === 'phone' && !props.send_phone_otp &&
                        <React.Fragment>
                            <div className='edit-email-phone-modal__form__actual-data'>
                                <div className='baloa-names'>{props.t('settings.editEmailPhoneModal.actualPhoneLbl')}</div>
                                <div className='baloa-names'><strong>+{props.value}</strong></div>
                            </div>
                            <div className='baloa-names'>{props.t('settings.editEmailPhoneModal.phoneTxt1')}</div>
                            <div className='baloa-names'>{props.t('settings.editEmailPhoneModal.phoneTxt2')}</div>
                            {/* <InputFieldComponent 
                                label={props.t(`settings.editEmailPhoneModal.${props.field}Lbl`)} 
                                input_id={props.field}
                                field_name={props.field}
                                validationFunction={ getValidator(props.field) }
                                disabled={false}
                                className=""
                                input_type={"text"}
                                resetError={ () =>props.resetError( {'field':props.field, 'error':''} ) }
                                error={ props.errors }
                                message=""
                                placeholder=""
                                //defaultValue={props.value}
                                //value={fieldValue}
                                //onChange={handleChange}
                            /> */}
                            <div className='baloa-table'>{props.t(`settings.editEmailPhoneModal.${props.field}Lbl`)}</div>
                            <div className='edit-email-phone-modal__form__phone'>                                
                                <LeagueCountrySearchIconComponent
                                    id = {'country_code'}
                                    fieldName={'country_code'}
                                    options= {props.constantsSingup?.countries?.filter((country) => country.content !== 'Código país') || props.constantsSingup?.countries?.filter((country) => country.content !== 'Country code')}
                                    modalSearchPlaceholder={props.t('settings.editEmailPhoneModal.searchCountryPlaceholder')}
                                    placeholderIndicative={props.constantsSingup?.countries?.filter((country) => country.content === 'Código país')[0] || props.constantsSingup?.countries?.filter((country) => country.content === 'Country code')[0] }
                                    validationFunction={ RequiredValidator }
                                    error={ { phone: "", country_code: "" } }
                                    resetError={() => { }}
                                    defaultValue={props.constantsSingup?.countries?.filter((country) => country.value === '1')[0]}
                                />
                                <div className="edit-email-phone-modal__vertical-separator__container">
                                    <div className="edit-email-phone-modal__vertical-separator" />
                                </div>
                                <InputFieldComponent
                                    input_id={props.field}
                                    field_name={props.field}
                                    validationFunction={ getValidator(props.field)}
                                    disabled={false}
                                    className=""
                                    type="text"
                                    resetError={ () =>props.resetError( {'field':props.field, 'error':''} ) }
                                    error={props.errors}
                                    message=""
                                />                                
                            </div>
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                className='test_class'
                                hl="en"
                                size="normal"
                                sitekey={recaptcha_public_key}
                                onChange={(value)=>{onChangeCaptcha(value)}}
                            />
                        </React.Fragment>
                    }
                    {props.field === 'phone' && props.send_phone_otp &&
                        <React.Fragment>
                            <div className="edit-email-phone-modal__code-title">
                                <span className="icon-arrow-left" onClick={ () => {props.phoneOtpSendAction(false )} }/>
                                <div className="baloa-subtitle-2">{props.t('settings.editEmailPhoneModal.codeVerificationSubtitle')}</div>
                            </div>
                            
                            <div className="baloa-names">{props.t('settings.editEmailPhoneModal.addVerificatioinCodeLbl')}<br></br> <span>+{props.value}</span></div>
                            <InputFieldComponent 
                                label={props.t(`settings.editEmailPhoneModal.codeLbl`)} 
                                input_id={'code'}
                                field_name={'code'}
                                validationFunction={ getValidator('code') }
                                disabled={false}
                                className="edit-email-phone-modal__otp-input"
                                input_type={"text"}
                                resetError={ () =>props.resetError( {'field':'code', 'error':''} ) }
                                error={ props.errors }
                                message=""
                                placeholder=""
                                maxLength="5"
                                //defaultValue={props.value}
                                //value={fieldValue}
                                //onChange={handleChange}
                            />

                            {/* Retry Otp */}
                            {isMobile?
                                <React.Fragment>
                                    <div className="edit-email-phone-modal__resend">
                                        <div className="baloa-names">{props.t('settings.editEmailPhoneModal.resendCodeLbl')} <strong>{`${ minutes }:${seconds.toString().padStart(2, '0')} ${props.t('settings.editEmailPhoneModal.minutesLbl') }`}</strong></div> 
                                    </div> 
                                    <TextButtonComponent
                                        input_type={'button'} 
                                        disabled  = { totalSeconds > 0} 
                                        onClick   = { async () => { 
                                            let token = await generateBaloaToken( props.value );
                                            props.onEditEmailPhone( 'resend_phone', { phone: props.value, baloa_token: token } );
                                            resetTimer();
                                        } } 
                                        className = "small">
                                        <span>{props.t('settings.editEmailPhoneModal.resendCodeBtnLbl')}</span>
                                    </TextButtonComponent>
                                </React.Fragment>
                            :
                                <div className="">
                                    
                                    <div className="edit-email-phone-modal__resend">
                                        <div className="baloa-names">{props.t('settings.editEmailPhoneModal.resendCodeLbl')} <strong>{`${ minutes }:${seconds.toString().padStart(2, '0')} ${props.t('settings.editEmailPhoneModal.minutesLbl') }`}</strong></div> 
                                    </div>                        
                                    
                                    <div className="edit-email-phone-modal__resend-buttons">                            
                                        <TextButtonComponent
                                            input_type={'button'} 
                                            disabled  = { totalSeconds > 0} 
                                            onClick   = { async () => { 
                                                let token = await generateBaloaToken( props.value );
                                                props.onEditEmailPhone( 'resend_phone', { phone: props.value, baloa_token: token } );
                                                resetTimer();
                                            } } 
                                            className = "small">
                                            <span>{props.t('settings.editEmailPhoneModal.resendCodeBtnLbl')}</span>
                                        </TextButtonComponent>
                                        <PrimaryButtonComponent type="submit" disabled={totalSeconds === 0 || !isFormValid} onClick={()=>{}} className="small">
                                            <span>{props.t('settings.editEmailPhoneModal.validateCodeBtnLbl')}</span>
                                        </PrimaryButtonComponent>
                                        
                                    </div>

                                </div>
                            }
                        </React.Fragment>
                    }

                    {props.field === 'email' && !props.send_email_otp &&
                        <React.Fragment>
                            <div className='edit-email-phone-modal__form__actual-data'>
                                <div className='baloa-names'>{props.t('settings.editEmailPhoneModal.actualEmailLbl')}</div>
                                <div className='baloa-names'><strong>{props.value}</strong></div>
                            </div>
                            <div className='baloa-names'>{props.t('settings.editEmailPhoneModal.emailTxt1')}</div>
                            <div className='baloa-names'>{props.t('settings.editEmailPhoneModal.emailTxt2')}</div>
                            <InputFieldComponent 
                                label={props.t(`settings.editEmailPhoneModal.${props.field}Lbl`)} 
                                input_id={props.field}
                                field_name={props.field}
                                validationFunction={ getValidator(props.field) }
                                disabled={false}
                                className=""
                                input_type={"text"}
                                resetError={ () =>props.resetError( {'field':props.field, 'error':''} ) }
                                error={ props.errors }
                                message=""
                                placeholder=""
                                //defaultValue={props.value}
                                //value={fieldValue}
                                //onChange={handleChange}
                            />
                        </React.Fragment>
                    }

                    {props.field === 'email' && props.send_email_otp &&
                        <React.Fragment>
                            <div className="edit-email-phone-modal__code-title">
                                <span className="icon-arrow-left" onClick={ () => {props.emailOtpSendAction(false )} }/>
                                <div className="baloa-subtitle-2">{props.t('settings.editEmailPhoneModal.codeVerificationSubtitle')}</div>
                            </div>
                            
                            <div className="baloa-names">{props.t('settings.editEmailPhoneModal.addVerificatioinCodeLbl')}<br></br> <span>{props.value}</span></div>
                            <InputFieldComponent 
                                label={props.t(`settings.editEmailPhoneModal.codeLbl`)} 
                                input_id={'email_code'}
                                field_name={'email_code'}
                                validationFunction={ getValidator('code') }
                                disabled={false}
                                className="edit-email-phone-modal__otp-input"
                                input_type={"text"}
                                resetError={ () =>props.resetError( {'field':'email_code', 'error':''} ) }
                                error={ props.errors }
                                message=""
                                placeholder=""
                                maxLength="5"
                                //defaultValue={props.value}
                                //value={fieldValue}
                                //onChange={handleChange}
                            />

                            {/* Retry email Otp */}
                            {isMobile?
                                <React.Fragment>
                                    <div className="edit-email-phone-modal__resend">
                                        <div className="baloa-names">{props.t('settings.editEmailPhoneModal.resendCodeLbl')} <strong>{`${ minutes }:${seconds.toString().padStart(2, '0')} ${props.t('settings.editEmailPhoneModal.minutesLbl') }`}</strong></div> 
                                    </div> 
                                    <TextButtonComponent
                                        input_type={'button'} 
                                        disabled  = { totalSeconds > 0} 
                                        onClick   = { async () => { 
                                            props.onEditEmailPhone( 'email', { email: props.value, user_id: props.user_id } );
                                            resetTimer();
                                        } } 
                                        className = "small">
                                        <span>{props.t('settings.editEmailPhoneModal.resendCodeBtnLbl')}</span>
                                    </TextButtonComponent>
                                </React.Fragment>
                            :
                                <div className="">                                
                                    <div className="edit-email-phone-modal__resend">
                                        <div className="baloa-names">{props.t('settings.editEmailPhoneModal.resendCodeLbl')} <strong>{`${ minutes }:${seconds.toString().padStart(2, '0')} ${props.t('settings.editEmailPhoneModal.minutesLbl') }`}</strong></div> 
                                    </div>                        
                                    <div className="edit-email-phone-modal__resend-buttons">                            
                                        <TextButtonComponent
                                            input_type={'button'} 
                                            disabled  = { totalSeconds > 0} 
                                            onClick   = { async () => { 
                                                props.onEditEmailPhone( 'email', { email: props.value, user_id: props.user_id } );
                                                resetTimer();
                                            } } 
                                            className = "small">
                                            <span>{props.t('settings.editEmailPhoneModal.resendCodeBtnLbl')}</span>
                                        </TextButtonComponent>
                                        <PrimaryButtonComponent type="submit" disabled={totalSeconds === 0 || !isFormValid} onClick={()=>{}} className="small">
                                            <span>{props.t('settings.editEmailPhoneModal.validateCodeBtnLbl')}</span>
                                        </PrimaryButtonComponent>                                    
                                    </div>                                
                                </div>
                            }
                        </React.Fragment>
                    }
                    
                    
                </FormComponent>
                {!props.send_phone_otp && !props.send_email_otp &&
                    <div className="edit-email-phone-modal__form-actions">
                        <PrimaryButtonComponent 
                            type="submit"
                            disabled={false} 
                            onClick={ ()=>{formRef.current.handleSubmit()} }
                            className={'small'}
                        >
                            <span>{props.t('settings.editEmailPhoneModal.continueBtnLbl')}</span>
                        </PrimaryButtonComponent>
                    </div>
                }
                {isMobile && (props.send_phone_otp || props.send_email_otp) &&
                    <div className="edit-email-phone-modal__form-actions">
                        <PrimaryButtonComponent 
                            type="submit" 
                            disabled={totalSeconds === 0 || !isFormValid}
                            className="small"
                            onClick={ ()=>{formRef.current.handleSubmit()} }
                        >
                            <span>{props.t('settings.editEmailPhoneModal.validateCodeBtnLbl')}</span>
                        </PrimaryButtonComponent>
                    </div>
                }
                
        </Modal2Component>
    )
}

export default withTranslation(['profile', 'validator'])(EditEmailPhoneModalComponent)